import { render } from "./ComplexitySelect.vue?vue&type=template&id=7522ea25"
import script from "./ComplexitySelect.vue?vue&type=script&lang=js"
export * from "./ComplexitySelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__